import React, { useMemo } from 'react';
import { ProductRevenuePanel } from '../../components/dashboard/ProductRevenuePanel';
import { RevenueMixPanel } from '../../components/dashboard/RevenueMixPanel';
import { PageSummaryStats } from '../../components/dashboard/PageSummaryStats';
import { DashboardInsightChip } from '../../components/dashboard/DashboardInsightChip';
import ErrorBoundary from '../../components/ErrorBoundary';
import { SkeletonChart } from '../../components/ui/SkeletonBlock';
import { buildProductSummaryStats } from '../../lib/pageSummaryStats';
import { buildProductsInsight } from '../../lib/dashboardInsights';

export function ProductsPage({
  committedFilters,
  data,
  panelLoading,
  error,
  isFirstLoad,
  currencyCode = 'DKK',
  currencyUnavailable = false,
  filterSlot = null,
}) {
  const queryKey = committedFilters.queryString || '';
  const productStats = useMemo(
    () =>
      buildProductSummaryStats(data?.revenueByProduct || [], {
        currencyCode,
        currencyUnavailable,
      }),
    [data?.revenueByProduct, currencyCode, currencyUnavailable]
  );
  const insight = useMemo(
    () => buildProductsInsight(data?.revenueByProduct || [], currencyCode),
    [data?.revenueByProduct, currencyCode]
  );

  return (
    <section className="flex w-full min-w-0 flex-col gap-5">
      <PageSummaryStats
        stats={productStats}
        isFirstLoad={isFirstLoad}
        error={error}
        emptyMessage="No product data found for this period. Try a different date range or filter."
      />

      {filterSlot}

      {!isFirstLoad && !error && insight ? (
        <DashboardInsightChip tone={insight.tone} title={insight.title} detail={insight.detail} />
      ) : null}

      {isFirstLoad ? (
        <div className="grid gap-4 xl:grid-cols-3">
          <div className="xl:col-span-2"><SkeletonChart height="h-[380px]" /></div>
          <SkeletonChart height="h-[380px]" />
        </div>
      ) : (
        <div className="grid items-stretch gap-4 xl:grid-cols-3">
          <div className="min-w-0 xl:col-span-2">
            <ErrorBoundary key={`prod-${queryKey}`}>
              <ProductRevenuePanel
                revenueByProduct={data?.revenueByProduct || []}
                loading={panelLoading}
                error={error}
                variant="detailed"
                currencyCode={currencyCode}
              />
            </ErrorBoundary>
          </div>
          <div className="min-w-0">
            <ErrorBoundary key={`mix-${queryKey}`}>
              <RevenueMixPanel
                revenueByProduct={data?.revenueByProduct || []}
                loading={panelLoading}
                error={error}
                variant="detailed"
                currencyCode={currencyCode}
              />
            </ErrorBoundary>
          </div>
        </div>
      )}
    </section>
  );
}
